import { j as C } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: o = 20,
  height: r = 20,
  viewBox: t = "0 0 20 20",
  fill: s = "currentColor",
  ...n
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: o,
    height: r,
    viewBox: t,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M9.99999 16.6667C13.6819 16.6667 16.6667 13.6819 16.6667 10C16.6667 6.3181 13.6819 3.33333 9.99999 3.33333C6.31809 3.33333 3.33332 6.3181 3.33332 10C3.33332 13.6819 6.31809 16.6667 9.99999 16.6667ZM9.99999 18.3333C5.39761 18.3333 1.66666 14.6023 1.66666 10C1.66666 5.39762 5.39761 1.66666 9.99999 1.66666C14.6023 1.66666 18.3333 5.39762 18.3333 10C18.3333 14.6023 14.6023 18.3333 9.99999 18.3333ZM9.99999 13.3333C11.8409 13.3333 13.3333 11.8409 13.3333 10C13.3333 8.15905 11.8409 6.66666 9.99999 6.66666C8.15904 6.66666 6.66666 8.15905 6.66666 10C6.66666 11.8409 8.15904 13.3333 9.99999 13.3333ZM9.99999 15C7.23856 15 4.99999 12.7614 4.99999 10C4.99999 7.23857 7.23856 5 9.99999 5C12.7614 5 15 7.23857 15 10C15 12.7614 12.7614 15 9.99999 15ZM9.99999 11.6667C9.07949 11.6667 8.33332 10.9205 8.33332 10C8.33332 9.0795 9.07949 8.33333 9.99999 8.33333C10.9205 8.33333 11.6667 9.0795 11.6667 10C11.6667 10.9205 10.9205 11.6667 9.99999 11.6667Z",
        fill: s
      }
    )
  }
);
export {
  l as default
};
